module.exports = __webpack_public_path__ + "static/media/PayRoll2.3bc3bae2.png";